import { SvgFunctionComponent } from '../../types';

// Components
import User from './svg/user.svg?react';
import Helpful from './svg/helpful.svg?react';
import SocialEngagment from './svg/social-engagement.svg?react';
import Reveal from './svg/reveal.svg?react';
//Svg
import socialEngagment from './svg/social-engagement.svg?raw';
import reveal from './svg/reveal.svg?raw';

export const ICON_SVG = {
  reveal: `data:image/svg+xml;utf8,${reveal}`,
  'social-engagement': `data:image/svg+xml;utf8,${socialEngagment}`,
};

export const ICON_SVG_COMPONENT = {
  reveal: Reveal as SvgFunctionComponent,
  user: User as SvgFunctionComponent,
  helpful: Helpful as SvgFunctionComponent,
  'social-engagement': SocialEngagment as SvgFunctionComponent,
};
